import script from "./GoalsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoalsPage.vue?vue&type=script&setup=true&lang=ts"

import "./GoalsPage.vue?vue&type=style&index=0&id=138461c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-138461c0"]])

export default __exports__